"use client";

import { GamesGrid } from "@/components/feature/games-grid";
import { GamesRows } from "@/components/feature/games-rows";
import type { PageOriginContext } from "@/lib/page-origin-context";
import type { ContentOrderWithGames } from "@/types/content-order";
import type { GameWithRelations } from "@/types/game";

interface TopicLandingGamesSectionProps {
  games: GameWithRelations[];
  contentOrders: ContentOrderWithGames[] | null;
  hasCuratedRows: boolean;
  emptyMessage: string;
  emptyDescription: string;
  pageOrigin?: PageOriginContext | null;
}

export function TopicLandingGamesSection({
  games,
  contentOrders,
  hasCuratedRows,
  emptyMessage,
  emptyDescription,
  pageOrigin,
}: TopicLandingGamesSectionProps) {
  if (hasCuratedRows) {
    return (
      <GamesRows
        contentOrders={contentOrders ?? undefined}
        emptyMessage={emptyMessage}
        emptyDescription={emptyDescription}
        pageOrigin={pageOrigin}
      />
    );
  }

  return (
    <GamesGrid
      games={games}
      emptyMessage={emptyMessage}
      emptyDescription={emptyDescription}
      pageOrigin={pageOrigin}
      linkPrefetch={false}
    />
  );
}
